const OPEN_MODAL = "OPEN_MODAL"
const CLOSE_MODAL = "CLOSE_MODAL"

export { CLOSE_MODAL, OPEN_MODAL }
